<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalStudentCBTSubmenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/student/exam-questions",
                title: "Take Exam",
                description: "Open available computer-based exams and submit your answers.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
